import { GetReportsResponse } from '@trukt/tms-api/ReportServices';
import { SidebarItem } from '@trukt/ui/Sidebar';
import { useMemo } from 'react';
import { generatePath } from '@shared/router';

export function useMemoItems(items: GetReportsResponse[], path: string) {
  return useMemo(
    () =>
      items.flatMap((page) =>
        page.results.map<SidebarItem>((result) => ({
          label: result.name,
          id: result.id,
          to: generatePath(path, { reportId: result.id }),
        })),
      ) || [],
    [items, path],
  );
}
